class FormSchemaAccessModel {

    constructor(...formSchemas) {
        this._formSchemas = formSchemas;
        this.pages = this.getPages();
    }

    /**
     * Return all page objects from the this._formSchemas
     * @returns {Object} - write a description
     */
    getPages = () => {
        return this._formSchemas.reduce((allPages, schema) => {
            const { stateKey } = schema.formProperties;
            const currentValue = allPages[stateKey] || [];
            return {
                ...allPages,
                [stateKey]: currentValue.concat(schema.pages)
            };
        }, {});
    };

    /**
     * @desc Extract and return all FieldSet definitions from this._formSchemas
     * @returns {Object} - All FieldSet definitions
     */
    getAllFieldSets = () => {
        return Object.keys(this.pages).reduce(
            (allFieldSets, stateKey) => {
                // eslint-disable-next-line no-param-reassign
                allFieldSets[stateKey] = this.pages[stateKey].reduce(
                    (fieldSets, page) => {
                        if (page.elements) {
                            fieldSets.push(...page.elements.filter((e) => e.elType === 'fieldSet'));
                        }
                        return fieldSets;
                    }, [],
                );
                return allFieldSets;
            }, {}
        );
    };

    /**
     * Return the FieldSet that matches the given identifier
     * @param {String} identifier - The identifier of the FieldSet to get
     * @returns {Object} - The matching FieldSet
     */
    getFieldSet = (identifier) => {
        const allFieldSets = this.getAllFieldSets();
        for (const stateKey of Object.keys(allFieldSets)) {
            const fieldSet = allFieldSets[stateKey].find((_fieldSet) => _fieldSet.identifier === identifier);
            if (fieldSet) {
                return fieldSet;
            }
        }
        return null; // keep eslint happy
    };

    /**
     * Return the FieldRow that matches the given identifier
     * @param {String} identifier - The identifier of the FieldRow to get
     * @returns {Object} - The matching FieldRow
     */
    getFieldRow = (identifier) => {
        const fieldSet = this.getFieldSetForElement(identifier);
        return fieldSet.elements.find((fieldRow) => fieldRow.identifier === identifier);
    };

    /**
     * Return the FieldSet that is the parent of the FieldRow that has identifier === id
     * @param {String} id - The FieldRow id to search for
     * @returns {Object|null} - The matching FieldSet or null if the FieldRow doesn't exist
     */
    getFieldSetForElement = (id) => {
        for (const stateKey of Object.keys(this.pages)) {
            for (const page of this.pages[stateKey]) {
                if (!page.elements) {
                    continue;
                }
                const foundFieldSet = page.elements.find((fieldSet) => fieldSet.elements.find((el) => el.identifier === id));
                if (foundFieldSet !== undefined) {
                    return foundFieldSet;
                }
            }
        }
        return null;
    };

}

export { FormSchemaAccessModel };
